import XeroSerializer from './base';

export default class Connection extends XeroSerializer {}
